const filterData = (data, nameList, index) => {
  if (!data) {
    return undefined;
  }
  const name = nameList[index];
  if (!name) {
    return data
  }
  return data.map(i => {
    if (i.name === name) {
      return {
        ...i,
        isOpen: true,
        children: filterData(i.children, nameList, index + 1),
      };
    } else {
      return null;
    }
  }).filter(i => i)
}

const addNameList = (data, nameList) => {
  if (!data) {
    return undefined;
  }
  return data.map(i => {
    const newList = [...nameList, i.name];
    return {
      ...i,
      nameList: newList,
      id: i.name,
      children: addNameList(i.children, newList),
    }
  })
}

const setLevels = (levels: any[], flag: number): any => {
  return levels.map((level: any, index: number): any => {
    return {
      ...level,
      upperLabel: level.upperLabel ? {
        ...level.upperLabel,
        show: flag < index + 1,
      } : {
        show: flag < index + 1,
      }
    }
  })
}

interface Option {
  debounceTimer: number;
}
const defaultOption = {
  debounceTimer: 500,
}
export default class TreemapHelper {
  private chart: any;
  private data: any;
  private timer: number;
  private option: Option;
  constructor(chart: any, option?: Option) {
    this.chart = chart;
    this.data = null;
    this.timer = 0;
    this.option = {
      ...defaultOption,
      ...option,
    }
  }

  formatData(data) {
    this.data = addNameList(data, []);
    return this.data;
  }

  click(event: any, callbcak: any) {
    const now = new Date().getTime();
    if (now - this.timer < this.option.debounceTimer) {
      return;
    }
    this.timer = now;
    if (event.data.isOpen) {
      // 收起
      const levels = this.chart.getModel().getOption().series[0].levels;
      this.chart.play({
        option: {
          series: [{
            data: this.data,
            levels: setLevels(levels, 1),
          }]
        }
      })
      callbcak({...event, eventType: 'clickTitleClose'})
    } else if (event.data.children && event.data.children.length) {
      // 展开
      const filter = filterData(this.data, event.data.nameList, 0);
      const levels = this.chart.getModel().getOption().series[0].levels
      this.chart.play({
        option: {
          series: [{
            data: filter,
            levels: setLevels(levels, event.data.nameList.length),
          }]
        }
      })
      callbcak({...event, eventType: 'clickTitleOpen'})
    } else {
      // 点击矩形
      callbcak({...event, eventType: 'clickItem'})
    }
  }
}